import React, { Component } from 'react';

import { Row, Col, Card } from 'antd';
import { Margin } from 'styled-components-spacing';
import Center from 'react-center';

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/Introduction/Missions.css";

const IntroductionCard = {
    borderRadius: "20px",
    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
}

const IntroductionCardHeader = {
    fontFamily: "IranSans",
    color: "#174561",
    fontSize: "1.1em",
    paddingRight: "10px",
    paddingTop: "3px"
}
const Strategy = props => {

    return props.size === "laptopdesktop" ? (
        <div style={{ backgroundColor: "#ffffff" }}>
            <Row>
                <Col span={4}></Col>
                <Col span={16}>
                    <div style={IntroductionCard}>
                        <Margin top={5}></Margin>
                        <Row>
                            <Col span={16}>
                                <div style={{ backgroundColor: "#f5f5f5", height: "100%", borderRadius: "20px 0 0 20px", padding: "30px" }}>
                                    <p className="textParagraph">
                                        • استفاده از روش های مدیریت پیمان و کنترل پروژه‌های متمرکز و غیر متمرکز
                                        <br/>
                                        • ارائه خدمات بیش از انتظار مشتری 
                                        <br />
                                        • شبکه‌سازی منابع انسانی مورد نیاز ارائه خدمات در سطح کشور
                                        <br />
                                        • استفاده از ظرفیت کارشناسی ارزیابان خسارت، حقوق دانان، کارآگاهان و دانش آموخته های بیمه ای در کل کشور
                                        <br />
                                        • ارائه خدمات مورد انتظار بیمه گران با بهترین کیفیت وکم ترین هزینه 
                                        <br />
                                        • استفاده از دانش ضمنی کارشناسان و متخصصان با سابقه در حوزه بیمه 
                                        <br />
                                        • توانمندسازی پرسنل و کارشناسان هلدینگ
                                        <br />
                                        • جذب نخبگان و متخصصان حرفه ای در حوزه ارزیابی خسارت بیمه ای
                                        <br />
                                        • انجام پژوهش های کاربردی در حوزه بیمه ای
                                    </p>
                                </div>
                            </Col>
                            <Col span={8} style={{ direction: "rtl", textAlign: "right" }}>
                                <div className="miniCardTitleBorder" style={{
                                    position: 'absolute', left: '50%', top: '50%',
                                    transform: 'translate(-50%, -50%)'
                                }}>                                    
                                    <p className="miniCardTitle"><strong>استراتژی های کلان</strong></p>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Col>
                <Col span={4}></Col>
            </Row>
        </div>
    ) : props.size === "tablet" ? (
            <div>
                <Row>
                    <Col span={2}></Col>
                    <Col span={20}>
                        <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                <Center>
                                    <Margin top={4}>
                                        <div>
                                            <p className="cardTitleTablet"><strong>استراتژی های کلان</strong></p>
                                        </div>
                                    </Margin>
                                </Center>
                                <Center>
                                    <hr className="cardTitleHRTablet" />
                                </Center>
                                <Margin top={2}></Margin>
                                <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                    <p className="textParagraphTablet" style={{ paddingTop: "10px" }}>
                                        • استفاده از روش های مدیریت پیمان و کنترل پروژه‌های متمرکز و غیر متمرکز
                                        <br />
                                        • ارائه خدمات بیش از انتظار مشتری
                                        <br />
                                        • شبکه‌سازی منابع انسانی مورد نیاز ارائه خدمات در سطح کشور
                                        <br />
                                        • استفاده از ظرفیت کارشناسی ارزیابان خسارت، حقوق دانان، کارآگاهان و دانش آموخته های بیمه ای در کل کشور
                                        <br />
                                        • ارائه خدمات مورد انتظار بیمه گران با بهترین کیفیت وکم ترین هزینه
                                        <br />
                                        • استفاده از دانش ضمنی کارشناسان و متخصصان با سابقه در حوزه بیمه
                                        <br />
                                        • توانمندسازی پرسنل و کارشناسان هلدینگ
                                        <br />
                                        • جذب نخبگان و متخصصان حرفه ای در حوزه ارزیابی خسارت بیمه ای
                                        <br />
                                        • انجام پژوهش های کاربردی در حوزه بیمه ای
                                    </p>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col span={2}></Col>
                </Row>
            </div>

    ) : (
                <div>
                    <Row>
                        <Col span={2}></Col>
                        <Col span={20}>
                            <div style={{ boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)", backgroundColor: "#fff", height: "100%", borderRadius: "20px" }}>
                                <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px 20px 0 0" }}>
                                    <Center>
                                        <Margin top={4}>
                                            <div>
                                                <p className="cardTitleMobile"><strong>استراتژی های کلان</strong></p>
                                            </div>
                                        </Margin>
                                    </Center>
                                    <Center>
                                        <div style={{ marginTop: "-10px" }} className="cardTitleHRMobile"></div>
                                    </Center>
                                    <Margin top={2}></Margin>
                                    <div style={{ paddingRight: "15px", paddingLeft: '15px', backgroundColor: "#fff" }}>
                                        <p className="textParagraphMobile" style={{ paddingTop: "10px" }}>
                                            • استفاده از روش های مدیریت پیمان و کنترل پروژه‌های متمرکز و غیر متمرکز
                                        <br />
                                        • ارائه خدمات بیش از انتظار مشتری
                                        <br />
                                        • شبکه‌سازی منابع انسانی مورد نیاز ارائه خدمات در سطح کشور
                                        <br />
                                        • استفاده از ظرفیت کارشناسی ارزیابان خسارت، حقوق دانان، کارآگاهان و دانش آموخته های بیمه ای در کل کشور
                                        <br />
                                        • ارائه خدمات مورد انتظار بیمه گران با بهترین کیفیت وکم ترین هزینه
                                        <br />
                                        • استفاده از دانش ضمنی کارشناسان و متخصصان با سابقه در حوزه بیمه
                                        <br />
                                        • توانمندسازی پرسنل و کارشناسان هلدینگ
                                        <br />
                                        • جذب نخبگان و متخصصان حرفه ای در حوزه ارزیابی خسارت بیمه ای
                                        <br />
                                        • انجام پژوهش های کاربردی در حوزه بیمه ای
                                    </p>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col span={2}></Col>
                    </Row>
                </div>
            );
};

export default Strategy;
